import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form'; // バリデーションライブラリ
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { menu } from '../../../constants';
import { useAuth } from '../../../context/AuthContext';
import { validationSchema } from '../../../utils/validationUtils'; // バリデーション定義ファイル
import { errorMessages } from '../../../utils/messagesUtils'; // エラーメッセージ
import sty from './Signin.module.css';

const LoginMng = () => {
    const navigate = useNavigate();
    const { setLoginUser, setRole } = useAuth();
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: 'onBlur', // フォーカスが外れたときにバリデーションを実行
    });

    // ログイン済みか確認
    const [previouslyLoggedIn, setPreviouslyLoggedIn] = useState(false);
    useEffect(() => {
        (async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/mng/auth/check`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache, no-store, must-revalidate'
                    },
                    credentials: 'include',
                    cache: 'no-store'
                });
                const data = await response.json();
                if (response.status === 200 && data.status === 'OK') {
                    setPreviouslyLoggedIn(true)
                } else {
                    setPreviouslyLoggedIn(false)
                }
            } catch (e) {
                // network failure
                setPreviouslyLoggedIn(false)
            }
        })()
    }, [])

    // パスワード表示・非表示
    const [passwordVisible, setPasswordVisible] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    // エラーメッセージ表示
    const [errorFromServer, setErrorFromServer] = useState('')

    // ログイン処理
    const onSubmit = async (data) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/mng/signin`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate'
                },
                body: JSON.stringify(data),
                credentials: 'include',
                cache: 'no-store'
            })
            const result = await response.json()
            if (response.status === 200 && result.status === 'OK') { 
                // Auth Context にログインユーザーとロールを設定
                setLoginUser(result.data.name)
                setRole(result.data.role)
                navigate(menu.MNG.HOME.PATH)
            } else {
                if (response.status === 429) {
                    // ログイン試行回数エラー(15分に5回まで)
                    const error = new Error();
                    error.front_message = errorMessages.login.too_many_attempts;
                    throw error;
                }else if (response.status === 401) { 
                    // ログイン認証エラー
                    const error = new Error();
                    error.front_message = errorMessages.login.invalid_credentials;
                    throw error;
                }else{
                    // それ以外のエラー
                    const error = new Error();
                    error.front_message = errorMessages.login.login_failed;
                    throw error;
                }
            }
        } catch (e) {
            // サーバーエラー
            setErrorFromServer(e.front_message || errorMessages.login.login_failed)
        }
    };

    if (previouslyLoggedIn) {
        return <Navigate to={menu.MNG.HOME.PATH} replace={true} />
    } else {
        return (
            !previouslyLoggedIn &&
            <form onSubmit={handleSubmit(onSubmit)} className="bg">
                <div className="account-container" >
                    <div className="page-tit">
                        <div className="page-tit-outer">
                            <p className="page-tit-txt">ログイン</p>
                            <p className="page-tit-txt page-tit-txt--mng">［管理者用］</p>
                            <div className="page-tit-border page-tit-border--mng"></div>
                        </div>
                    </div>
                    <div className="inner-container">
                        {errorFromServer && <p className='account-error-msg'>{errorFromServer}</p>}
                        <div className={sty['login__mail']}>
                            <div className={sty['login__mail-mail-tit']}>
                                <label htmlFor="email">メールアドレス</label>
                            </div>
                            <div className={sty['login__mail-mail-tit']}>
                                <input {...register('email', validationSchema.email)} type="email" className={sty['login__email-input']} id="email" autoComplete="email" placeholder="taro.yamada@example.com" />
                                {errors.email && <p className="form__validation-msg"
                                >{errors.email.message}</p>}
                            </div>
                        </div>

                        <div className={sty['login__pass']}>
                            <div className={sty['login__pass-pass-tit']}>
                                <label htmlFor="password">パスワード</label>
                            </div>
                            <div className={sty['login__pass-pass-tit']}>
                                <div className={sty['login__pass-pass-ex']}>
                                    <input {...register('password', validationSchema.password)} type={passwordVisible ? 'text' : 'password'}
                                        className={sty['login__pass-input-field']} placeholder="パスワードを入力してください" id="password" />
                                    {errors.password && <p className="form__validation-msg">{errors.password.message}</p>}
                                    <img src={passwordVisible ? '/images/open.svg' : '/images/hidden.svg'}
                                        alt="パスワード表示・非表示" className={`${sty['login__pass-toggle']} ${passwordVisible ? sty['login__pass-toggle--open'] : ''}`}
                                        onClick={togglePasswordVisibility} />
                                </div>
                                <div className={sty['login__pass-forgot']}>
                                    <Link to="/forgot-password" state={{ role: 1 }}>パスワードをお忘れの方</Link>
                                </div>
                            </div>
                        </div>
                        <div className="primary-btns">
                            <button type="submit" className="primary-btn btn-large">ログイン</button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default LoginMng;
